import './styles/name-filter.scss'

import React     from 'react'
import PropTypes from 'prop-types'

export default class NameFilter extends React.Component {
  static propTypes = {
    onFilterChange:   PropTypes.func.isRequired,
    selectedCategory: PropTypes.string.isRequired,
    filterCriteria:   PropTypes.object.isRequired,
  }
  
  state = {
    value: '',
  }

  constructor(props) {
    super(props)
    this.propsToState(props)
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.propsToState(props)
  }

  propsToState(props) {
    const { filterCriteria, selectedCategory } = props

    const value = filterCriteria && filterCriteria[selectedCategory] && filterCriteria[selectedCategory].like
      ? filterCriteria[selectedCategory].like
      : ''

    this.setState({ value })
  }

  handeValueChange = (event) => {
    this.setState({ value: event.currentTarget.value })
  }

  handleKeyEvent = (event) => {
    if (event.key === "Enter") {
      this.notifyChange()
    }
  }

  handleClear = () => {    
    this.setState({ value: '' }, () => {
      setTimeout(this.notifyChange, 100)
    })
  }

  notifyChange = () => {
    this.props.onFilterChange({ like: this.state.value.replace(/;/g,'_') })
  }

  render() {
    const { value } = this.state

    const iconClass = value
      ? 'x icon'
      : 'search icon'

    return (
      <div className="name-filter">
        <div className="ui icon input">

          <input
            type="text"
            placeholder="Search by name..."
            value={value}
            onChange={this.handeValueChange}
            onKeyPress={this.handleKeyEvent}
          />

          <i className={iconClass} onClick={this.handleClear} />
        </div>
      </div>
    )
  }
}